import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const chargesDetails = createAsyncThunk('charges/details', async ({ id, cycle_type, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `charges/${id}`,
            params: {
                ...(cycle_type ? { cycle_type } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addCharges = createAsyncThunk('charges/add', async (data) => {

    let charges = data?.values?.charges?.map(val => ({
        "id": val?.id,
        "charge_type_id": val?.type,
        "pricing_type": val?.pricing_type,
        "charge_amount": val?.amount,
    }))

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'charges',
            data: {
                "premise_id": data?.values?.premise,
                "cycle_type": data?.values?.cycle_type,
                "charges": charges,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const charges = createSlice({
    name: 'charges',
    initialState: {
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(chargesDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default charges.reducer;